import style from './index.module.scss';

const ReferencesComments = ({ commentsData }: { commentsData: string | null | undefined }) => {
  return (
    <div className={style.wrap}>
      {commentsData && (
        <div className={style.message}>
          <div>
            <span className={style.hr}>HR</span>
          </div>
          <div className={style.chatText}>{commentsData}</div>
        </div>
      )}
    </div>
  );
};

export default ReferencesComments;
